import React from 'react';
import Button from 'style-guide/component/Button';
import { QuestionNavigationProps } from '../types/questionTypes';

const QuestionNavigation: React.FC<QuestionNavigationProps> = ({
  currentQuestion,
  totalQuestions,
  onBack,
  onNext,
  onSave,
  isLoading = false,
}) => {
  const isLastQuestion = currentQuestion === totalQuestions - 1;
  const buttonText = isLastQuestion ? "Save" : "Next";
  const handleClick = isLastQuestion ? onSave : onNext;

  return (
    <div className="h-[72px] w-full fixed bottom-0 right-0 pl-[120px] flex justify-between items-center bg-white p-4 border-t-[#D9D9D9] border-t-[1px]">
      <Button
        type="Default"
        size="Large"
        buttonText="Back"
        onClick={onBack}
        loading={isLoading}
      />
      <Button
        type="Primary"
        size="Large"
        buttonText={buttonText}
        onClick={handleClick}
        loading={isLoading}
      />
    </div>
  );
};

export default QuestionNavigation;
